import React from "react";
import { Table } from "react-bootstrap";

import { RatingsTableProps } from "../types/myschedule";

import { useAppSelector } from "../../../../hooks/reduxHooks";
import { selectSetting } from "../../../../features/global/globalSlice";

const RatingsTable = ({
    type,
    ratings,
}: RatingsTableProps): React.JSX.Element => {
    const currentYear = useAppSelector(state =>
        selectSetting(state, "umphub_current_league_year"),
    );
    const header =
        type === "current"
            ? `Current Year (${currentYear?.setting})`
            : "Prior Years";

    return (
        <Table striped>
            <thead>
                <tr>
                    <th colSpan={2}>{header}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Games Umped</td>
                    <td>{ratings?.games || "N/A"}</td>
                </tr>
                <tr>
                    <td>Consistency</td>
                    <td>{ratings?.consistency || "N/A"}</td>
                </tr>
                <tr>
                    <td>Effort</td>
                    <td>{ratings?.effort || "N/A"}</td>
                </tr>
                <tr>
                    <td>Attitude</td>
                    <td>{ratings?.attitude || "N/A"}</td>
                </tr>
                <tr>
                    <td>Consistency</td>
                    <td>{ratings?.consistency || "N/A"}</td>
                </tr>
                <tr>
                    <td>Total Ratings</td>
                    <td>{ratings?.count || "N/A"}</td>
                </tr>
            </tbody>
        </Table>
    );
};

export default RatingsTable;
